import React from 'react';
import classNames from 'classnames/bind';
import styles from './CartEmptyState.module.scss';

const cx = classNames.bind(styles);

const CartEmptyState = ({
    message = "Your bag is empty",
    className
}) => {
    return (
        <div className={cx("cart-empty", className)}>
            <div className={cx("cart-empty__icon")}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                    <circle cx="8" cy="21" r="1" />
                    <circle cx="19" cy="21" r="1" />
                    <path d="m2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                </svg>
            </div>
            <p className={cx("cart-empty__message")}>{message}</p>
        </div>
    );
};

export default CartEmptyState;
